import { useEffect, useRef, type ComponentProps } from 'react';

import { Input } from '../ui/field.tsx';

/**
 * 6-digit code from the authenticator app: numeric keyboard on phones, one-time-code
 * autofill, and `onComplete` as soon as 6 digits are typed.
 */
export function CodeInput({
  value,
  onChange,
  onComplete,
  ...props
}: Omit<ComponentProps<'input'>, 'onChange' | 'value' | 'ref'> & {
  value: string;
  onChange: (value: string) => void;
  onComplete?: (value: string) => void;
}) {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    ref.current?.focus();
  }, []);
  return (
    <Input
      ref={ref}
      inputMode="numeric"
      autoComplete="one-time-code"
      pattern="[0-9]*"
      maxLength={6}
      className="text-center font-mono text-2xl tracking-[0.5em]"
      value={value}
      onChange={(event) => {
        const digits = event.target.value.replace(/\D/g, '').slice(0, 6);
        onChange(digits);
        if (digits.length === 6) onComplete?.(digits);
      }}
      {...props}
    />
  );
}
